import React, { FC } from "react";
import { useFormContext } from "react-hook-form";

import { getTechSheetFieldSlugifiedName } from "../../../../../utils/products";
import { Input } from "../../../../forms";
import { ProductFinderFiltersFormTypes } from "../../types";

export interface TextFieldFilterProps extends Queries.TechSheetFieldDataFragment {}

export const TextFieldFilter: FC<TextFieldFilterProps> = ({ internalName, label }) => {
  const fieldName = getTechSheetFieldSlugifiedName(internalName ?? "");
  const { watch, setValue } = useFormContext<ProductFinderFiltersFormTypes>();

  return (
    <div className="flex-grow flex-shrink-0 flex items-end" key={fieldName}>
      <Input
        label={label}
        value={watch(fieldName) as string}
        onChange={(e) => setValue(fieldName, e.target.value)}
        className="w-full"
      />
    </div>
  );
};
